/* Approved-v6.19 homepage motion with deferred media loading; visual behavior retained. */
(() => {
 'use strict';
 if(globalThis.PAPreviewHome) { globalThis.PAPreviewHome.mount(); return; }
 const states=new Map();
 function initialize(root){
  if(states.has(root))return;
  const realDocument=globalThis.document, realWindow=globalThis.window;
  const controller=new AbortController(), observers=[], frames=new Set(), mediaListeners=[];
  const add=(target,type,callback,options={})=>target.addEventListener(type,callback,{...(typeof options==='boolean'?{capture:options}:options),signal:controller.signal});
  const document={
   querySelector:selector=>root.querySelector(selector),
   querySelectorAll:selector=>root.querySelectorAll(selector),
   createElement:tag=>realDocument.createElement(tag),
   get hidden(){return realDocument.hidden;},
   get baseURI(){return realDocument.baseURI;},
   get documentElement(){return root;},
   addEventListener:(type,fn,opts)=>add(realDocument,type,fn,opts),
   removeEventListener:(...args)=>realDocument.removeEventListener(...args)
  };
  const requestAnimationFrame=fn=>{let id=realWindow.requestAnimationFrame(time=>{frames.delete(id);fn(time);});frames.add(id);return id;};
  const cancelAnimationFrame=id=>{frames.delete(id);realWindow.cancelAnimationFrame(id);};
  const matchMedia=query=>{
   const result=realWindow.matchMedia(query);
   return new Proxy(result,{get(target,key){
    if(key==='addEventListener')return(type,fn,opts)=>{target.addEventListener(type,fn,opts);mediaListeners.push(()=>target.removeEventListener(type,fn,opts));};
    const value=Reflect.get(target,key,target);return typeof value==='function'?value.bind(target):value;
   }});
  };
  const window=new Proxy(realWindow,{get(target,key){
   if(key==='addEventListener')return(type,fn,opts)=>add(target,type,fn,opts);
   if(key==='requestAnimationFrame')return requestAnimationFrame;
   if(key==='cancelAnimationFrame')return cancelAnimationFrame;
   if(key==='matchMedia')return matchMedia;
   const value=Reflect.get(target,key,target);return typeof value==='function'?value.bind(target):value;
  }});
  const IntersectionObserver=realWindow.IntersectionObserver?class extends realWindow.IntersectionObserver{
   constructor(callback,options){super(callback,options);observers.push(this);}
  }:undefined;
  const cleanup=()=>{controller.abort();observers.forEach(o=>o.disconnect());frames.forEach(realWindow.cancelAnimationFrame.bind(realWindow));mediaListeners.forEach(fn=>fn());root.querySelectorAll('video').forEach(v=>v.pause());states.delete(root);};
  states.set(root,cleanup);
  // Media URLs stay inert in data-src until the image-first hero is ready or
  // a lower-page phone is approaching the viewport. Existing URLs remain valid.
  function hydrateDeferredVideo(video){
   if(controller.signal.aborted)return false;
   let changed=false;
   const activate=element=>{
    const source=element.getAttribute('data-src');
    if(!source)return;
    element.setAttribute('src',source);element.removeAttribute('data-src');changed=true;
   };
   activate(video);video.querySelectorAll('source[data-src]').forEach(activate);
   if(changed){video.preload='metadata';video.load();}
   return changed;
  }
(() => { const $ = (selector,scope=document) => scope.querySelector(selector);
  const video=$('#pa-preview-brand-film'), control=$('#pa-preview-film-toggle');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(video&&control){
    let inView=false,manualPaused=false,userStarted=false,blocked=false,intentToPlay=false,request=0,completed=false,primaryReady=false,primaryScheduled=false;
    function label(playing){control.setAttribute('aria-pressed',String(playing));const symbol=$('.play-symbol',control),text=$('#pa-preview-film-label');if(symbol)symbol.textContent=playing?'Ⅱ':'▷';if(text)text.textContent=playing?'Pause the moment':completed?'Replay the moment':'Play the moment';}
    function allowed(){return !completed&&inView&&!document.hidden&&!manualPaused&&(userStarted||(primaryReady&&!reduced.matches&&!blocked));}
    function pause(){request++;intentToPlay=false;video.pause();label(false);}
    function sync(){
      if(!allowed()){pause();return;}
      if(intentToPlay)return;
      const current=++request;
      intentToPlay=true;label(true);
      // Setting these properties before play also supports inline muted playback on mobile.
      video.muted=true;video.defaultMuted=true;video.playsInline=true;
      hydrateDeferredVideo(video);
      function failed(){
        if(current!==request)return;
        blocked=true;userStarted=false;intentToPlay=false;label(false);
        if($('#pa-preview-film-label'))$('#pa-preview-film-label').textContent='Play the moment';
      }
      try{
        Promise.resolve(video.play()).then(()=>{
          // An old request must not pause a newer valid one or revive cancelled playback.
          if(current!==request){if(!intentToPlay||!allowed())video.pause();return;}
          if(!allowed()){pause();return;}
          video.parentElement.classList.add('playing');label(true);
        }).catch(failed);
      }catch{failed();}
    }
    function afterPrimaryImage(){
      if(primaryScheduled)return;
      primaryScheduled=true;
      // Let the critical still paint before video decoding/network competes.
      requestAnimationFrame(()=>requestAnimationFrame(()=>{primaryReady=true;sync();}));
    }
    const primaryImage=video.parentElement.querySelector('img');
    if(!primaryImage||primaryImage.complete)afterPrimaryImage();
    else{add(primaryImage,'load',afterPrimaryImage,{once:true});add(primaryImage,'error',afterPrimaryImage,{once:true});}
    window.addEventListener('pageshow',event=>{if(event.persisted)sync();});
    video.muted=true;
    control.addEventListener('click',()=>{
      if(intentToPlay){manualPaused=true;userStarted=false;pause();return;}
      if(completed){completed=false;video.currentTime=0;video.parentElement.classList.remove('film-complete','playing');}
      manualPaused=false;userStarted=true;blocked=false;sync();
    });
    video.addEventListener('playing',()=>{if(!intentToPlay||!allowed()){video.pause();return;}video.parentElement.classList.add('playing');label(true);});
    video.addEventListener('pause',()=>label(false));
    video.loop=false;
    video.addEventListener('ended',()=>{completed=true;request++;intentToPlay=false;userStarted=false;video.parentElement.classList.add('film-complete');video.parentElement.classList.remove('playing');label(false);});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)userStarted=false;sync();});
    reduced.addEventListener('change',()=>{if(reduced.matches)userStarted=false;sync();});
    function visible(value){inView=value;if(!inView)userStarted=false;sync();}
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{const entry=entries[entries.length-1];visible(entry.isIntersecting&&entry.intersectionRatio>=.15);},{threshold:[0,.15]});
      observer.observe(video.parentElement);
    }else{
      const measure=()=>{
        const rect=video.parentElement.getBoundingClientRect?.();if(!rect)return;
        const width=Math.max(0,Math.min(rect.right,window.innerWidth)-Math.max(rect.left,0));
        const height=Math.max(0,Math.min(rect.bottom,window.innerHeight)-Math.max(rect.top,0));
        visible(rect.width>0&&rect.height>0&&width*height/(rect.width*rect.height)>=.15);
      };
      window.addEventListener('scroll',measure,{passive:true});window.addEventListener('resize',measure);measure();
    }
  }
})();
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const wide = window.matchMedia('(min-width: 701px)');
  const all = selector => [...document.querySelectorAll(selector)];
  let cleanup = () => {};

  function initialize() {
    cleanup();
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const disposers = [];
    const targets = [];
    const headings = all('.shop-intro h2,.everyday-heading h2,.details-title h2,.fit-intro h2,.closing h2');
    for (const heading of headings) {
      if (!heading.dataset.motionLines) {
        const lines = heading.innerHTML.split(/<br\s*\/?>/i);
        heading.innerHTML = lines.map((line,index) => '<span class="motion-line"><span class="motion-line-inner" style="--line:'+index+'">'+line+'</span></span>').join(' ');
        heading.dataset.motionLines = 'true';
      }
      heading.classList.add('motion-heading');
      targets.push(heading);
    }
    all('.life-card').forEach((card,index) => {
      card.classList.add('motion-photo');
      card.style.setProperty('--enter-delay', Math.min(index*110,220)+'ms');
      targets.push(card);
    });
    all('.detail-photo,.product-stage,.feature-list,.fit-questions,.weight').forEach(el=>{
      el.classList.add('motion-content');
      targets.push(el);
    });
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if(entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }, {threshold:.08,rootMargin:'0px 0px -20px 0px'});
    targets.forEach(el=>observer.observe(el));
    document.documentElement.classList.add('motion-ready');
    disposers.push(()=>{observer.disconnect();document.documentElement.classList.remove('motion-ready');});

    const hero = document.querySelector('.hero');
    const sequence = document.querySelector('.hero-sequence');
    let frame=0, heroActive=true;
    function updateHero() {
      frame=0;
      if(!hero||!sequence||!heroActive||document.hidden||!wide.matches) return;
      const box=sequence.getBoundingClientRect();
      const header=92;
      const travel=Math.max(0,header-box.top);
      const progress=Math.min(1,travel/(window.innerHeight*.7));
      hero.style.setProperty('--hero-scale',(1.015+progress*.065).toFixed(4));
      hero.style.setProperty('--hero-type-y',(-progress*32).toFixed(1)+'px');
    }
    function schedule(){if(!frame&&heroActive)frame=window.requestAnimationFrame(updateHero);}
    if(hero&&sequence) {
      const visibility=new IntersectionObserver(entries=>{heroActive=entries[0].isIntersecting;if(heroActive)schedule();},{rootMargin:'100px'});
      visibility.observe(sequence);
      const settled=event=>{if(event.animationName==='pa-preview-photo-settle')hero.classList.add('hero-settled');};
      hero.addEventListener('animationend',settled);
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule,{passive:true});
      wide.addEventListener('change',schedule);
      schedule();
      disposers.push(()=>{visibility.disconnect();hero.removeEventListener('animationend',settled);window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);wide.removeEventListener('change',schedule);if(frame)window.cancelAnimationFrame(frame);hero.style.removeProperty('--hero-scale');hero.style.removeProperty('--hero-type-y');hero.classList.remove('hero-settled');});
    }

    const resetProperties=(el,names)=>names.forEach(name=>el.style.removeProperty(name));
    all('.life-card').forEach(card=>{
      let pointerFrame=0,lastX=0,lastY=0;
      const reset=()=>{if(pointerFrame)window.cancelAnimationFrame(pointerFrame);pointerFrame=0;resetProperties(card,['--photo-x','--photo-y','--caption-x','--caption-y']);};
      const move=event=>{
        if(!finePointer.matches)return;
        const box=card.getBoundingClientRect();
        lastX=((event.clientX-box.left)/box.width-.5)*14;
        lastY=((event.clientY-box.top)/box.height-.5)*14;
        if(!pointerFrame)pointerFrame=window.requestAnimationFrame(()=>{
          pointerFrame=0;card.style.setProperty('--photo-x',lastX.toFixed(1)+'px');card.style.setProperty('--photo-y',lastY.toFixed(1)+'px');card.style.setProperty('--caption-x',(-lastX*.35).toFixed(1)+'px');card.style.setProperty('--caption-y',(-lastY*.35).toFixed(1)+'px');
        });
      };
      card.addEventListener('pointermove',move);card.addEventListener('pointerleave',reset);card.addEventListener('blur',reset);
      disposers.push(()=>{reset();card.removeEventListener('pointermove',move);card.removeEventListener('pointerleave',reset);card.removeEventListener('blur',reset);});
    });
    all('.hero-bottom .button,.closing .button').forEach(button=>{
      const reset=()=>resetProperties(button,['--magnet-x','--magnet-y']);
      const move=event=>{if(!finePointer.matches)return;const box=button.getBoundingClientRect();button.style.setProperty('--magnet-x',((event.clientX-box.left-box.width/2)*.07).toFixed(1)+'px');button.style.setProperty('--magnet-y',((event.clientY-box.top-box.height/2)*.12).toFixed(1)+'px');};
      button.addEventListener('pointermove',move);button.addEventListener('pointerleave',reset);button.addEventListener('blur',reset);
      disposers.push(()=>{reset();button.removeEventListener('pointermove',move);button.removeEventListener('pointerleave',reset);button.removeEventListener('blur',reset);});
    });
    cleanup=()=>{disposers.forEach(dispose=>dispose());cleanup=()=>{};};
  }
  initialize();
  reduced.addEventListener('change',initialize);
  window.addEventListener('pagehide',()=>cleanup());
  window.addEventListener('pageshow',event=>{if(event.persisted)initialize();});
})();

(() => {
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  if('IntersectionObserver' in window&&!reduced.matches){
    const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.animate?.([{opacity:.35,transform:'translateY(35px)'},{opacity:1,transform:'translateY(0)'}],{duration:750,easing:'cubic-bezier(.16,.7,.22,1)'});observer.unobserve(e.target);}}),{threshold:.12});
    document.querySelectorAll('.collection-card,.world-story,.social-card').forEach(el=>observer.observe(el));
  }
  const socials=[...document.querySelectorAll('.social-video video')];
  // Each phone plays independently. No live social APIs or background playback.
  const states=new Map();
  const stop=s=>{
    if(!s.video.paused){s.internalPauses++;s.video.pause();}
  };
  const sync=s=>{
    if(!s.visible||document.hidden){stop(s);return;}
    if(reduced.matches||s.manualPause||s.blocked||s.pending||!s.video.paused)return;
    hydrateDeferredVideo(s.video);
    s.pending=true;
    try{
      Promise.resolve(s.video.play()).then(()=>{
        s.pending=false;
        if(!s.visible||document.hidden||s.manualPause||reduced.matches)stop(s);
      }).catch(()=>{s.pending=false;s.blocked=true;});
    }catch(_){s.pending=false;s.blocked=true;}
  };
  socials.forEach(video=>{
    video.muted=true;video.defaultMuted=true;video.playsInline=true;
    const s={video,visible:false,near:false,manualPause:false,blocked:false,pending:false,internalPauses:0};
    states.set(video,s);
    // Native video controls must work even if clicked before a near-view callback.
    add(video,'pointerdown',()=>hydrateDeferredVideo(video));
    add(video,'keydown',event=>{if(event.key===' '||event.key==='Enter')hydrateDeferredVideo(video);});
    video.addEventListener('pause',()=>{
      if(s.internalPauses){s.internalPauses--;return;}
      s.manualPause=true;
    });
    video.addEventListener('play',()=>{
      hydrateDeferredVideo(video);
      // A native-controls play action also permits a blocked autoplay retry.
      if(!s.pending){s.manualPause=false;s.blocked=false;}
      if(!s.visible||document.hidden)stop(s);
    });
  });
  if('IntersectionObserver' in window){
    const loading=new IntersectionObserver(entries=>entries.forEach(e=>{
      const s=states.get(e.target);s.near=e.isIntersecting;
      if(s.near&&!document.hidden)hydrateDeferredVideo(s.video);
    }),{rootMargin:'800px 0px',threshold:0});
    socials.forEach(video=>loading.observe(video));
    const playback=new IntersectionObserver(entries=>entries.forEach(e=>{
      const s=states.get(e.target);
      s.visible=e.isIntersecting&&e.intersectionRatio>=.3;sync(s);
    }),{threshold:[0,.3]});
    socials.forEach(video=>playback.observe(video));
  }else{
    const check=()=>states.forEach(s=>{
      const r=s.video.getBoundingClientRect();
      s.near=r.bottom>-800&&r.top<window.innerHeight+800;
      if(s.near&&!document.hidden)hydrateDeferredVideo(s.video);
      s.visible=r.bottom>0&&r.top<window.innerHeight;sync(s);
    });
    window.addEventListener('scroll',check,{passive:true});
    window.addEventListener('resize',check);check();
  }
  const refresh=()=>states.forEach(s=>{
    if(s.near&&!document.hidden)hydrateDeferredVideo(s.video);
    sync(s);
  });
  document.addEventListener('visibilitychange',refresh);
  window.addEventListener('pageshow',event=>{if(event.persisted)refresh();});
  reduced.addEventListener?.('change',()=>states.forEach(s=>{if(reduced.matches)stop(s);else sync(s);}));
  const route=location.pathname.split('/').pop();
  document.querySelectorAll('#main-nav a').forEach(a=>{if(a.getAttribute('href')===route)a.setAttribute('aria-current','page');});
})();

(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const counters = [...document.querySelectorAll('[data-count-value]')];
  const photographer = document.querySelector('.photographer-sprite');
  const finished = new WeakSet();
  const active = new Map();
  const format = number => Math.round(number).toLocaleString('en-US');
  let photographerVisible = false;
  function finish(el) {
    const frame = active.get(el);
    if (frame !== undefined) cancelAnimationFrame(frame);
    active.delete(el);
    el.textContent = format(Number(el.dataset.countValue));
    finished.add(el);
  }
  function start(el) {
    if (finished.has(el) || active.has(el)) return;
    if (reduced.matches || document.hidden) { finish(el); return; }
    const target = Number(el.dataset.countValue);
    const began = performance.now();
    el.textContent = '0';
    function tick(now) {
      if (reduced.matches || document.hidden) { finish(el); return; }
      const progress = Math.min(1, Math.max(0, (now - began) / 800));
      el.textContent = format(target * (1 - Math.pow(1 - progress, 3)));
      if (progress === 1) finish(el);
      else active.set(el, requestAnimationFrame(tick));
    }
    active.set(el, requestAnimationFrame(tick));
  }
  function syncPhotographer() {
    photographer?.classList.toggle('is-snapping', photographerVisible && !reduced.matches && !document.hidden);
  }
  if ('IntersectionObserver' in window) {
    const counterObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= .6) {
        start(entry.target);
        counterObserver.unobserve(entry.target);
      }
    }), { threshold: [0, .6] });
    counters.forEach(el => counterObserver.observe(el));
    if (photographer) {
      const doodleObserver = new IntersectionObserver(entries => {
        photographerVisible = entries.some(entry => entry.isIntersecting);
        syncPhotographer();
      });
      doodleObserver.observe(photographer);
    }
  } else {
    // Full values and a still photographer are the no-observer fallback.
    counters.forEach(finish);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) [...active.keys()].forEach(finish);
    syncPhotographer();
  });
  reduced.addEventListener?.('change', () => {
    if (reduced.matches) counters.forEach(finish);
    syncPhotographer();
  });
})();

(() => {
  const icon = document.querySelector('.cameraman-once');
  if (!icon) return;
  const stage = icon.querySelector('.cameraman-stage');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const cameraAsset = root.dataset.cameraAsset;
  const setCameraArtwork=()=>stage.style.setProperty('--camera-art','url('+JSON.stringify(cameraAsset)+')');
  if (!('IntersectionObserver' in window)) {if(cameraAsset)setCameraArtwork();return;}
  const layers = [0, 1].map(() => {
    const layer = document.createElement('span');
    layer.className = 'cameraman-layer';
    stage.appendChild(layer);
    return layer;
  });
  const poses = [[0,0],[-265,0],[-541,-1],[-818,-2],[0,-337],[-264,-337]];
  const sequence = [[0,0,1700],[0,2,160],[2,2,600],[3,3,75],[3,2,90],[2,2,625],[2,0,160]];
  const duration = sequence.reduce((sum, part) => sum + part[2], 0);
  let elapsed = 0, last = null, frame = null, visible = false, ready = false, near = false, loading = false;
  function pose(layer, index, y = 0) {
    const p = poses[index];
    layer.style.backgroundPosition = p[0] + 'px ' + p[1] + 'px';
    layer.style.clipPath = index === 2 ? 'polygon(0 0,86% 0,86% 76%,100% 76%,100% 100%,0 100%)' : 'none';
    layer.style.transform = 'translateY(' + y.toFixed(2) + 'px)';
  }
  function draw() {
    let t = elapsed, part = sequence[0];
    for (const item of sequence) { part = item; if (t < item[2]) break; t -= item[2]; }
    const [from, to, length] = part, progress = Math.min(1, t / length);
    const blend = progress * progress * (3 - 2 * progress);
    const travel = from === 0 && to === 2 ? -2 : from === 2 && to === 0 ? 2 : 0;
    pose(layers[0], from, travel * blend);
    pose(layers[1], to, -travel * (1 - blend));
    layers[1].style.opacity = from === to ? '0' : String(blend);
  }
  function pause() {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null; last = null;
  }
  function still() {
    pause();
    pose(layers[0], 2); layers[1].style.opacity = '0';
    icon.dataset.animationState = 'reduced-motion';
  }
  function tick(now) {
    frame = null;
    if (!ready || reduced.matches || !visible || document.hidden) { sync(); return; }
    if (last !== null) elapsed += Math.min(now - last, 80);
    last = now;
    elapsed %= duration;
    draw(); frame = requestAnimationFrame(tick);
  }
  function sync() {
    if (!ready) { pause(); return; }
    if (reduced.matches) { still(); return; }
    if (!visible || document.hidden) {
      pause(); icon.dataset.animationState = 'paused'; return;
    }
    draw();
    icon.dataset.animationState = 'playing';
    if (frame === null) frame = requestAnimationFrame(tick);
  }
  const observer = new IntersectionObserver(entries => {
    visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .4);
    sync();
  }, {threshold: [0, .4]});
  observer.observe(icon);
  function loadCamera(){
    if(loading||!cameraAsset||document.hidden)return;
    loading=true;
    const image=new Image();
    image.onload=()=>{
      if(controller.signal.aborted)return;
      // Use the exact asset_url revision for both preload and CSS layers.
      setCameraArtwork();ready=true;draw();stage.classList.add('has-layers');sync();
    };
    image.src=cameraAsset;
  }
  const loadingObserver=new IntersectionObserver(entries=>{
    near=entries.some(entry=>entry.isIntersecting);
    if(near)loadCamera();
  },{rootMargin:'800px 0px',threshold:0});
  loadingObserver.observe(icon);
  document.addEventListener('visibilitychange',()=>{if(near)loadCamera();sync();});
  window.addEventListener('pageshow',event=>{if(event.persisted){if(near)loadCamera();sync();}});
  reduced.addEventListener?.('change', sync);
})();

 }
 function mount(){globalThis.document.querySelectorAll('#pa-preview-home').forEach(initialize);}
 globalThis.PAPreviewHome={mount};
 if(globalThis.document.readyState==='loading')globalThis.document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
 globalThis.document.addEventListener('shopify:section:load',mount);
 globalThis.document.addEventListener('shopify:section:unload',event=>{for(const [root,cleanup] of states)if(event.target.contains(root))cleanup();});
})();

